import Vue from 'vue'
import Router from 'vue-router'
import iView from 'view-design'

import sider from '@/router/sider'
import Storage from '@/services/storage'

Vue.use(Router)

export const routers = [
  {
    path: '/',
    redirect: 'home'
  },
  {
    path: '/home',
    component: () => import('@/pages/Index'),
    children: sider
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/Login')
  },
  {
    path: '/print-sf2-express',
    name: 'print-sf2-express',
    component: () => import('@/pages/PmpRecordPage/PrintSf2ExpressLabel')
  },
  {
    path: '/print-sf2-express-zd',
    name: 'print-sf2-express-zd',
    component: () => import('@/pages/PmpRecordPage/PrintSf2ExpressLabelZd')
  },
  {
    path: '/office365-callback',
    name: 'office365-callback',
    component: () => import('@/pages/Office365CallbackPage')
  },
  {
    path: '/*',
    component: () => import('@/pages/Index')
  }
]

export const appRouter = []

export const router = new Router({
  routes: routers,
  mode: 'hash'
})
router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  let token = Storage.getItem('token')
  if (!token) {
    if (to.name !== 'login' && to.name !== 'office365-callback') {
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

router.afterEach(to => {
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})
